import { useEffect, useState } from "react";
import { Form, Offcanvas } from "react-bootstrap";
import { DashSquareFill, PlusSquareFill } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import WebService from "../../utility/WebService";
import { toast } from "react-toastify";
import CustomButton from "../../components/CustomButton/CustomButton";

interface AddWomenInEnergyProps {
    show: boolean;
    handleClose: () => void;
    data?: any; // existing document data
    leader?: any;
    mode?: "add" | "edit";
}

type FormData = {
    year: string;
};

const AddWomenLeaders = ({ show, handleClose, data, leader, mode }: AddWomenInEnergyProps) => {

    const { register, handleSubmit, formState: { errors }, reset } = useForm<FormData>();

    const [womens, setWomens] = useState<any[]>([
        { title: "", image: null, designation: "", company: "", linkedinUrl: ""  }
    ]);

    const [isLoading, setLoading] = useState(false);

    // RESET FORM WHEN OPEN
    useEffect(() => {
        if (mode === "edit" && leader) {
            reset({ year: leader.year });
            setWomens([{
                title: leader.title,
                image: leader.image,
                designation: leader.designation,
                company: leader.company || "",
                linkedinUrl: leader.linkedinUrl || "",
            }]);
        } else {
            reset({ year: "" });
            setWomens([{ title: "", image: null, designation: "", company: "", linkedinUrl: ""  }]);
        }

    }, [show, data, mode, leader]);

    const uploadFile = (file: File, index: number) => {
        const formData = new FormData();
        formData.append("file", file);
           formData.append("storage", "WOMEN_IN_ENERGY");
        WebService.fileUploadAPI({
            action: `upload`,
            body: formData
        }).then((res: any) => {
            womens[index].image = res.data?.url;
            setWomens([...womens]);
        });
    };

    const onSubmit = (request: FormData) => {
        if (!data?._id) {
            toast.error("Please save INFO first");
            return;
        }

        setLoading(true);

        // already saved leaders
        let allLeaders = data?.leaders || {};
        let year = request.year;

        if (mode == "add") {
            if (!allLeaders[year]) allLeaders[year] = [];

            womens.forEach((w) => {
                allLeaders[year].push(w);
            });
        }

        if (mode === "edit") {
            allLeaders[leader.year][leader.index] = womens[0]
        }


        const body = new FormData();
        body.append("leaders", JSON.stringify(allLeaders));
        body.append("id", data._id);

        WebService.fileUploadAPI({
            action: `women-in-energy/addLeaders`,
            body
        })
            .then((res: any) => {
                toast.success("Leader saved");
                setLoading(false);
                handleClose();
            })
            .catch(() => setLoading(false));
    };

    const yearOptions = ["1999", "2000", "2001", "2002", "2003", "2004", "2005", "2006", "2007", "2008", "2009", "2010", "2011", "2012", "2013", "2014", "2015", "2016", "2017", "2018", "2019", "2020", "2021", "2022", "2023", "2024", "2025"];

    return (
        <Offcanvas
            show={show}
            onHide={handleClose}
            placement="end"
            className="offcanvas-custom"
        >
            <Offcanvas.Header closeButton>
                <Offcanvas.Title>{mode==="add"?"Add Leader":"Edit Leader"}</Offcanvas.Title>
            </Offcanvas.Header>

            <Offcanvas.Body>
                <Form>

                    {/* YEAR DROPDOWN */}
                    <Form.Group className="mb-2">
                        <Form.Label className="label">Year</Form.Label>
                        <Form.Select
                            {...register("year", { required: "Year required" })}
                            disabled={mode === "edit"}
                        >
                            <option value="">Select Year</option>
                            {yearOptions.map((y) => (
                                <option key={y} value={y}>{y}</option>
                            ))}
                        </Form.Select>
                        {errors.year && <div className="error-message">{errors.year.message}</div>}
                    </Form.Group>

                    <Form.Group className="mb-2">
                        <Form.Label>Leaders</Form.Label>
                                 <p
                    className="text-primary mt-1"
                    style={{ fontSize: "13px" }}
                  >
                    Note: Please upload an image of size:{" "}
                    <strong>130 × 128 px</strong> in{" "}
                    <strong>.png, .jpeg, .jpg or .svg</strong> format.
                  </p>
                        {womens.map((item, index) => (
                            <div key={index} className="mb-4">

                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        const file = (e.target as HTMLInputElement).files?.[0];
                                        if (file) uploadFile(file, index);
                                    }}
                                />

                                {item.image && (
                                    <img src={item.image} width={80} className="mt-2" />
                                )}

                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    className="mt-2"
                                    value={item.title}
                                    onChange={(e) => {
                                        womens[index].title = e.target.value;
                                        setWomens([...womens]);
                                    }}
                                />

                                <Form.Control
                                    type="text"
                                    placeholder="Designation"
                                    className="mt-2"
                                    value={item.designation}
                                    onChange={(e) => {
                                        womens[index].designation = e.target.value;
                                        setWomens([...womens]);
                                    }}
                                />

                                {/* COMPANY */}
                                <Form.Control
                                    type="text"
                                    placeholder="Company"
                                    className="mt-2"
                                    value={item.company}
                                    onChange={(e) => {
                                        womens[index].company = e.target.value;
                                        setWomens([...womens]);
                                    }}
                                />

                                {/* LINKEDIN */}
                                <Form.Control
                                    type="text"
                                    placeholder="LinkedIn URL"
                                    className="mt-2"
                                    value={item.linkedinUrl}
                                    onChange={(e) => {
                                        womens[index].linkedinUrl = e.target.value;
                                        setWomens([...womens]);
                                    }}
                                />

                                <div className="d-flex mt-2">
                                    <PlusSquareFill
                                        className="cursor-pointer"
                                        onClick={() =>
                                            setWomens([...womens, { title: "", image: null, designation: "" }])
                                        }
                                    />
                                    {womens.length > 1 && (
                                        <DashSquareFill
                                            className="cursor-pointer ms-2"
                                            onClick={() =>
                                                setWomens(womens.filter((_, i) => i !== index))
                                            }
                                        />
                                    )}
                                </div>
                            </div>
                        ))}
                    </Form.Group>

                </Form>
            </Offcanvas.Body>

            <div className="p-3">
                <CustomButton
                    label="Save"
                    className="w-100"
                    isLoading={isLoading}
                    onClick={handleSubmit(onSubmit)}
                />
            </div>
        </Offcanvas>
    );
};

export default AddWomenLeaders;
